import { TemplateItem } from '@anm/api/modules/templates';
import { Player } from '@anm/components/VideoPlayer';
import noop from '@anm/helpers/noop';

import TemplateVideoPlayer from '../TemplateVideoPlayer';

export const getTemplateVideoWithPlayerRefs = (template: TemplateItem) => {
  const playerRef = {
    refs: [] as Player[],

    addRef(player: Player) {
      this.refs.push(player);
    }
  };

  return {
    playerRef,
    TemplateVideoPlayer: (
      <TemplateVideoPlayer
        key={template.templateId}
        variant="black"
        direction="column"
        position="top_buttons"
        onChangeRatio={noop}
        heightDependence="screen_dependence"
        templateKind={template.meta.kind}
        playerRef={player => playerRef.addRef(player)}
      />
    )
  };
};
